import { render, staticRenderFns } from "./DashboardNavbar.vue?vue&type=template&id=365b1158&"
import script from "./DashboardNavbar.vue?vue&type=script&lang=js&"
export * from "./DashboardNavbar.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNavbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports